





































































































































































import {Component, Emit, Mixins, Prop, PropSync, Watch} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {ClaimStatusType, RefundBankAccount, RefundType, SelectListItem} from '@/types/claim';
import {
  isCancelDone,
  isCancelNoRefund,
  isCancelProcRequestRefund,
  isCancelProcWaitingRefund,
  isCancelRequest,
  isReturnClaim,
  isReturnDone,
  isReturnProcRequestRefund,
  isReturnRefundAmtAdjustRequested
} from '@/components/claim/popup/validations';
import {PostOptionCancelsNoPredict, ReturnsPredict} from 'supporter';

@Component({
  components: {
    CompSelectBox
  },
  computed: {
    isCancelRequest,
    isCancelDone,
    isCancelNoRefund,
    isCancelProcWaitingRefund,
    isCancelProcRequestRefund,
    isReturnClaim,
    isReturnProcRequestRefund,
    isReturnRefundAmtAdjustRequested,
    isReturnDone,
    showRefundAccountSelect(){
      if((this.isCancelProcRequestRefund ||
        this.isReturnProcRequestRefund ||
        this.isReturnRefundAmtAdjustRequested ||
        this.isModifyMode) && (this.isAccountRefundType || this.isVirtualAccount)){
        return true;
      }

      // 히스토리: https://nhn-playart.dooray.com/project/posts/2955851033463038426
      if(this.isModifyMode && this.isZeroRefund){
        return true;
      }

      return false;
    },
    isZeroRefund(){
      // 취소/반품 화면에서는 +로 보이는 값이 환불 - 로 보이는 값이 추가결제... : claimAmt.negate()
      // 교환 화면에서는 -로 보이는 값이 환불 + 로 보이는 값이 추가결제... : claimAmt 랑 동일
      return this.adjustedAmounts.claimAmt >= 0
    },
    adjustAmountInputDisable(){
      return this.isModifyMode
    },
    hasRefundAccount(){
      return Boolean(this.refundBankAccountSync?.account)
    },
    isPG(){
      return this.claimNoResponseData.pgType !== 'NONE'
    },
    isVirtualAccount(){
      // modifymode true/false 시 환불방법 드롭박스 기준으로 가상계좌 파악해야하므로 sync로 판단.
      // 가상계좌: refundType: pg + payType: VIRTUAL_ACCOUNT
      // 일반PG:  refundType: pg + payType: 그 외
      return this.refundTypeSync === 'PG' && this.claimNoResponseData.originalPayType === 'VIRTUAL_ACCOUNT';
    },
    showRefundAccount(){
      if(!this.isCancelNoRefund && this.isAccountRefundType){
        return true;
      }

      if(this.isPG && this.isVirtualAccount && this.hasRefundAccount){
        return true;
      }

      if(!this.isPG && this.hasRefundAccount){
        return true;
      }

      return false;
    },
    hasRefundHoldReason(){
      return this.claimNoResponseData.refundHoldReason !== null
    },
    isAccountRefundType(){
      return this.refundTypeSync === RefundType.ACCOUNT
    },
    whenShowRefundExpectation(){
      return !this.isCancelDone && !this.isCancelNoRefund && !this.isReturnDone
    },
    whenRefundTypeCanModify(){
      return !this.isZeroRefund &&
        (this.isCancelProcRequestRefund || this.isReturnProcRequestRefund|| this.isReturnRefundAmtAdjustRequested || this.isModifyMode)
    },
    redHighlight(){
      return this.isReturnClaim
    }
  }
})
export default class RefundAmount extends Mixins(AmountMixin){
  @Prop({required: true})
  private readonly isModifyMode!: boolean
  @Prop({required: true})
  private claimStatusType!: ClaimStatusType
  @Prop({required: false})
  private readonly predict: null | ReturnsPredict | PostOptionCancelsNoPredict = null
  @PropSync('refundType')
  private refundTypeSync!: RefundType
  @PropSync('refundBankAccount')
  private refundBankAccountSync!: RefundBankAccount
  @PropSync('refundAdjustAmt')
  private refundAdjustAmtSync!: number
  @PropSync('refundAdjustReason')
  private refundAdjustReasonSync!: string

  private refundBankList: SelectListItem[] = []
  private refundTypeSelectList: SelectListItem[] = []

  // 취소처리[환불보류]상태에서는 환불방법 select박스가 enable하지만 option은 claimNo의 환불방법만 출력된다.
  @Watch('isModifyMode')
  @Watch('adjustedAmounts.claimAmt')
  private resetRefundTypeSelectList(){
    const {pgType, originalPayTypeLabel} = this.claimNoResponseData;

    if(this.isModifyMode){
      this.refundTypeSelectList = this.generateRefundTypeSelectList(this.adjustedAmounts, pgType, originalPayTypeLabel)
      return
    }

    this.refundTypeSelectList = this.generateRefundTypeSelectList(this.adjustedAmounts, pgType, originalPayTypeLabel).filter(refundSelectItem => {
      return refundSelectItem.value === this.refundTypeSync
    })
  }

  // refundType을 claimAmt가 0원일 때 프론트에서 ZERO_REFUND 바꾸어 보내줘야한다. 부모에서 claimAmt를 알 수 있도록 public 지정
  public adjustedAmounts = {
    claimAmt: 0, // 환불금액 a+b / 환불예상금액 a+b row
    accumulationPayAmt: 0, // 적립금사용반환
    mainPayAmt: 0, // 카드취소 / 현금환불액
  }

  async created(){
    this.resetRefundTypeSelectList()
    await this.fetchAndSetRefundBankList()
    this.setAdjustedAmounts()
    this.setRefundBankIfBankIsEmpty()
  }

  private async fetchAndSetRefundBankList(){
    const banksResponse = await this.$api.getBanks({params: { countryCode: 'KR'}})
    this.refundBankList = banksResponse.data.filter(bank => bank.value !== 'ANONYMOUS')
  }

  private setAdjustedAmounts(){
    const {claimAmt, accumulationPayAmt, mainPayAmt} = this.amounts.adjustedAmounts
    this.adjustedAmounts = {claimAmt, accumulationPayAmt, mainPayAmt}
  }

  public resetAsPredictedAmounts(){
    this.setPredictedAdjustedAmounts()
  }

  private setRefundBankIfBankIsEmpty(){
    if(!this.refundBankAccountSync.bank){
      this.refundBankAccountSync.bank = this.refundBankList[0].value as string
    }
  }

  private setPredictedAdjustedAmounts(){
    const {claimAmt, accumulationPayAmt, mainPayAmt} = this.predict.amounts.adjustedAmounts
    this.adjustedAmounts = {claimAmt, accumulationPayAmt, mainPayAmt}
  }

  private changeRefundAccountBankName(){
    const selectedBank = this.refundBankList.find(refundBank => refundBank.value === this.refundBankAccountSync.bank)
    this.refundBankAccountSync.bankName = selectedBank.name
  }

  @Emit('refundAdjustAmtBlur')
  private onAdjustAmtBlur(){
  }
}
